/* ==========================================================================
   THE FAVOURITES PAGE. Reads the list, fetches each rug, renders the grid.

   IT DEPENDS ON rug-wishlist.js AND SAYS SO RATHER THAN ASSUMING IT. Both are
   loaded from theme.liquid, but this file is `defer` on a section and the
   module is `defer` in the head, so ordering is guaranteed by the parser and
   not by luck — and if the module is ever absent this exits quietly leaving the
   honest empty state on screen, rather than throwing on `window.RugWishlist`.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-rz-favourites]');
  if (!root) return;

  var API = window.RugWishlist;
  if (!API) return;                       // the empty state is already correct

  var grid = root.querySelector('[data-rz-favs-grid]');
  var empty = root.querySelector('[data-rz-favs-empty]');
  var full = root.querySelector('[data-rz-favs-full]');

  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    /* The currency comes from the SHOP, through the money format Shopify gives
       us on the product payload — never a constant. CLAUDE.md records a price
       reaching a customer with no currency symbol at all because one was
       hardcoded, and a second currency would make a constant wrong. */
    return (fmt || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, v)
                                 .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)));
  }

  function tile(p) {
    var a = document.createElement('a');
    a.className = 'rz-fav-card__name';
    a.href = '/products/' + p.handle;

    var card = document.createElement('article');
    card.className = 'rz-fav-card';

    var wrap = document.createElement('div');
    wrap.className = 'fit-card__thumb-wrap';       // the positioned host the heart needs

    if (p.featured_image) {
      var img = document.createElement('img');
      img.className = 'rz-fav-card__thumb';
      img.src = p.featured_image;
      img.alt = p.title;
      img.loading = 'lazy';
      /* The listing PNGs are 2000x2000 and ~5 MB each. CLAUDE.md records six of
         them taking a page from 8.4s to 13.7s, and this grid can hold 200. */
      img.width = 600; img.height = 600;
      wrap.appendChild(img);
    }

    /* THE SALE BADGE, ON THE SAME QUESTION EVERY OTHER SURFACE ASKS:
       `compare_at_price_min > price_min`. The bare `compare_at_price` is the
       first variant's and every rug here carries a size range, so the min pair
       is the only one that means "this product is marked down at all".

       IT COSTS NO EXTRA REQUEST. `/products/<handle>.js` — already fetched
       above for the title, image and price — carries both figures.

       `aria-hidden` for the reason the other surfaces give: the price sits
       beside it as text, and "sale" then a price is one fact read twice. */
    if (typeof p.compare_at_price_min === 'number' &&
        typeof p.price_min === 'number' &&
        p.compare_at_price_min > p.price_min) {
      var badge = document.createElement('span');
      badge.className = 'rz-bcard__badge';
      badge.setAttribute('aria-hidden', 'true');
      badge.textContent = 'SALE';
      wrap.appendChild(badge);
    }

    var link = document.createElement('a');
    link.href = '/products/' + p.handle;
    link.className = 'rz-fav-card__link';
    link.setAttribute('aria-label', p.title);
    link.style.position = 'absolute';
    link.style.inset = '0';
    wrap.appendChild(link);

    card.appendChild(wrap);
    /* THE CUSTOMER-FACING NAME (2026-09-08). `window.RugName` is the same rule
       `snippets/rug-short-name.liquid` renders on every Liquid surface, reading
       the same two inputs — the title and the product type — both of which
       `/products/<handle>.js` already carries. NO MODULE, NO SHORTENING: the
       tile falls back to the full title rather than to an empty heading. */
    a.textContent = (window.RugName && window.RugName.from(p.title, p.type)) || p.title;
    card.appendChild(a);

    /* THE REVIEW STARS, UNDER THE NAME AND ABOVE THE PRICE (2026-09-07).

       IT COSTS NO REQUEST OF ITS OWN. `/products/<handle>.js` — the call this
       tile is already built from — carries `id` at the top level, which is
       exactly what the Loox widget needs, so the stars ride a response that
       has already arrived.

       ONE CALL FOR THE WHOLE PAGE, NOT ONE PER TILE. `RugLoox` debounces and
       asks its bulk `ratings` endpoint once for every pending widget in the
       document. The tiles resolve in parallel, so without that a page of
       twenty favourites would make twenty requests.

       NO MODULE, NO STARS, NO GAP. `widget()` returns null when there is no
       product id, and the tile simply carries no star row — the same rule
       every other surface follows, and the reason a rug with no reviews (none
       today, but a new design has none until somebody leaves one) gets nothing
       rather than a row of grey outlines. */
    if (window.RugLoox) {
      var stars = window.RugLoox.widget(p.id, 'rz-fav-card__stars');
      if (stars) card.appendChild(stars);
    }

    /* THE PRICE ROW, IN THE SAME ORDER AND THE SAME COLOURS AS EVERY OTHER
       CARD: how far off, then what it costs, then what it was, struck through.

       THE PERCENTAGE IS DERIVED FROM THE TWO FIGURES THIS TILE PRINTS, which
       is the rule `snippets/price.liquid` follows and for the same reason: a
       tile showing one price may not carry a percentage that is true of a
       different size. `Math.floor` because understating a discount is a claim
       we can meet and overstating one is not.

       THE BADGE ASKS A BROADER QUESTION THAN THIS ROW DOES, deliberately. It
       is gated on `compare_at_price_min > price_min` -- "is this product
       marked down at all" -- while the row is gated on the pair it is about
       to print. A product whose first size is not discounted but whose others
       are is still on sale, and still gets the badge. */
    if (typeof p.price === 'number') {
      var fmt = window.Shopify && window.Shopify.money_format;
      var pr = document.createElement('p');
      pr.className = 'rz-fav-card__price';

      var was = typeof p.compare_at_price === 'number' && p.compare_at_price > p.price
        ? p.compare_at_price : null;

      if (was) {
        var off = Math.floor((was - p.price) * 100 / was);
        if (off > 0) {
          var o = document.createElement('span');
          o.className = 'rz-off';
          /* `aria-hidden` for the reason the Liquid card gives: the two prices
             beside it say the same thing, and a screen reader announcing the
             percentage as well hears one fact twice. */
          o.setAttribute('aria-hidden', 'true');
          o.textContent = off + '% off';
          pr.appendChild(o);
        }
      }

      var now = document.createElement('span');
      now.className = 'rz-fav-card__now';
      now.textContent = money(p.price, fmt);
      pr.appendChild(now);

      if (was) {
        var w = document.createElement('s');
        w.className = 'rz-fav-card__was';
        w.textContent = money(was, fmt);
        pr.appendChild(w);
      }

      card.appendChild(pr);
    }
    return card;
  }

  function render() {
    var handles = API.list();
    if (!handles.length) {
      grid.hidden = true; grid.innerHTML = '';
      empty.hidden = false;
      if (full) full.hidden = true;
      return;
    }
    empty.hidden = true;

    Promise.all(handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { return p ? { handle: h, p: p } : { handle: h, p: null }; })
        .catch(function () {
          /* A NETWORK FAILURE IS NOT A DELISTED RUG, and the two must not share
             an answer. `undefined` means "could not ask"; `null` means "asked,
             and it is gone". Only the second removes anything. */
          return { handle: h, p: undefined };
        });
    })).then(function (results) {
      grid.innerHTML = '';
      var gone = [];
      results.forEach(function (r) {
        if (r.p === null) { gone.push(r.handle); return; }
        if (!r.p) return;                       // could not ask — leave it saved
        grid.appendChild(tile(r.p));
      });
      gone.forEach(function (h) { API.remove(h); });   // fires the event; harmless if empty

      grid.hidden = grid.children.length === 0;
      empty.hidden = grid.children.length !== 0;

      if (full) {
        var atCap = API.count() >= 200;
        full.hidden = !atCap;
        if (atCap) full.textContent = 'Favourites holds 200 rugs. Remove one to save another.';
      }
    });
  }

  window.addEventListener('rugzella:favourites', function () {
    /* Re-render on a change made ON THIS PAGE — un-hearting a tile should remove
       it, not leave a saved-looking card behind. */
    render();
  });

  render();
})();
